import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "448b79bd-5528-49ba-8055-75cd821814c8",
    content:
      "The lack of standards for measurement and rating of sound insulation, leaving it up to the national legislation to stipulate these procedures.",
    options: {},
  },
  {
    id: "4ae4d925-d3fb-4f6d-afb6-a68f892f1f9e",
    content:
      "Too many descriptors defined by the ISO 717 standard and their inconsistent use from one country to the next, inconsistent classification of sound insulation found in different countries, and extensions of relevant standards with non-standard requirements and procedures in certain countries, making any direct comparison of sound insulation performance impossible on a wider international level.",
    options: {},
  },
  { id: "a450ac55-1052-48b0-8e43-0dd09a7542ce", content: "Both a) and b).", options: {} },
  { id: "99abab61-d0d4-45d9-98ad-9be52d09daac", content: "Neither a), nor b).", options: {} },
];

export const task: Task = {
  id: "81f24407-d39d-4b2d-af7e-50a5ccc14f83",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 1,
    shuffle: false,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4ae4d925-d3fb-4f6d-afb6-a68f892f1f9e"],
};
